import React, { useState, useEffect } from 'react';
import './PromptModal.css';

const PromptModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  message,
  initialValue = '',
  submitText = 'OK',
  placeholder = '',
  isProcessing = false,
  processingText = '処理中...',
}) => {
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    if (isOpen) {
      setInputValue(initialValue);
    }
  }, [isOpen, initialValue]);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(inputValue);
  };

  return (
    <div className="prompt-modal-overlay" onClick={onClose}>
      <div className="prompt-modal-content" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <h2>{title}</h2>
          <p>{message}</p>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={placeholder}
            autoFocus
          />
          <div className="prompt-modal-actions">
            <button type="button" onClick={onClose} className="btn-cancel" disabled={isProcessing}>
              キャンセル
            </button>
            <button type="submit" className="btn-submit" disabled={isProcessing}>
              {isProcessing ? processingText : submitText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PromptModal;
